import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import * as Sentry from '@sentry/browser';
import { LeadReferrer } from '../shared/lead-referrer';
import { LeadReferrerString, DefaultLeadReferrerString } from '../shared/lead-referrer-string';

@Injectable({
  providedIn: 'root'
})
export class LeadReferrerService {
  leadReferrer: LeadReferrer;
  leadReferrerString: LeadReferrerString;
  clickId: string;
  cookieDomain: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cookieService: CookieService
  ) {
    let splitHost = window.location.hostname.split('.');
    this.cookieDomain = splitHost.length > 1
      ? splitHost[splitHost.length - 2] + '.' + splitHost[splitHost.length - 1]
      : window.location.hostname;
  }

  setReferrer() {
    if (!this.cookieService.check('lead_referrer') && !this.cookieService.check('fruRemoveCookies')) {
      const utm_content = this.route.snapshot.queryParams['utm_source'] === 's2'
        ? this.route.snapshot.queryParams['transaction_id']
        : '';

      this.leadReferrer = {
        source: this.route.snapshot.queryParams['utm_source'] || '',
        medium: this.route.snapshot.queryParams['utm_medium'] || '',
        campaign: this.route.snapshot.queryParams['utm_campaign'] || '',
        keyword: this.route.snapshot.queryParams['utm_keyword'] || '',
        content: this.route.snapshot.queryParams['utm_content'] || utm_content,
        network: this.route.snapshot.queryParams['network'] || '',
        placement: this.route.snapshot.queryParams['placement'] || '',
        gclid: this.route.snapshot.queryParams['gclid'] || '',
        clickid: this.route.snapshot.queryParams['msclkid'] || '',
        ttclid: this.route.snapshot.queryParams['ttclid'] || '',
        tt_test_id: this.route.snapshot.queryParams['tt_test_id'] || '',
      }

      if (isDevMode()) {
        console.log('setting referrer', this.leadReferrer);
      }

      let d = new Date();
      d.setDate(d.getDate() + 1);

      this.cookieService.set('lead_referrer', JSON.stringify(this.leadReferrer), d, '/', this.cookieDomain);
    } else {
      let cookie = this.cookieService.get('lead_referrer');
      let cookieParsed;

      try {
        cookieParsed = JSON.parse(cookie);
      } catch (e) {
        cookieParsed = {};
      }

      this.leadReferrer = {
        source: cookieParsed.source || '',
        medium: cookieParsed.medium || '',
        campaign: cookieParsed.campaign || '',
        keyword: cookieParsed.keyword || '',
        content: cookieParsed.content || '',
        network: cookieParsed.network || '',
        placement: cookieParsed.placement || '',
        gclid: cookieParsed.gclid || '',
        clickid: cookieParsed.clickid || '',
        ttclid: cookieParsed.ttclid || '',
        tt_test_id: cookieParsed.tt_test_id || '',
      }
    }

    if (!this.cookieService.check('lead_referrer_string') && !this.cookieService.check('fruRemoveCookies')) {
      this.leadReferrerString = DefaultLeadReferrerString;
      let d = new Date();
      d.setDate(d.getDate() + 1);
      this.cookieService.set('lead_referrer_string', JSON.stringify(this.leadReferrerString), d, '/', this.cookieDomain);
    } else {
      let cookie = this.cookieService.get('lead_referrer_string');
      let cookieParsed;

      try {
        cookieParsed = JSON.parse(cookie);
      } catch (e) {
        cookieParsed = {};
      }

      this.leadReferrerString = {
        http_referer: cookieParsed.http_referer || '',
        request_uri: cookieParsed.request_uri || '',
      }
    }
  }

  setReferrerNew() {
    if (!this.cookieService.check('lead_referrer') && !this.cookieService.check('fruRemoveCookies')) {
      const utm_content = this.route.snapshot.queryParams['utm_source'] === 's2'
        ? this.route.snapshot.queryParams['transaction_id']
        : '';
      this.leadReferrer = {
        source: this.route.snapshot.queryParams['utm_source'] || '',
        medium: this.route.snapshot.queryParams['utm_medium'] || '',
        campaign: this.route.snapshot.queryParams['utm_campaign'] || '',
        keyword: this.route.snapshot.queryParams['utm_keyword'] || '',
        content: this.route.snapshot.queryParams['utm_content'] || utm_content,
        network: this.route.snapshot.queryParams['network'] || '',
        placement: this.route.snapshot.queryParams['placement'] || '',
        gclid: this.route.snapshot.queryParams['gclid'] || '',
        clickid: this.route.snapshot.queryParams['msclkid'] || '',
        ttclid: this.route.snapshot.queryParams['ttclid'] || '',
        tt_test_id: this.route.snapshot.queryParams['tt_test_id'] || '',
      };

      console.log('setting referrer', this.leadReferrer);

      let d = new Date();
      d.setDate(d.getDate() + 1);
      this.cookieService.set('lead_referrer', JSON.stringify(this.leadReferrer), d, '/', this.cookieDomain);
      console.log('Cookie set:', this.cookieService.get('lead_referrer'));
    } else {
      let cookie = this.cookieService.get('lead_referrer');
      let cookieParsed;

      try {
        cookieParsed = JSON.parse(cookie);
      } catch (e) {
        cookieParsed = {};
      }

      this.leadReferrer = {
        source: cookieParsed.source || '',
        medium: cookieParsed.medium || '',
        campaign: cookieParsed.campaign || '',
        keyword: cookieParsed.keyword || '',
        content: cookieParsed.content || '',
        network: cookieParsed.network || '',
        placement: cookieParsed.placement || '',
        gclid: cookieParsed.gclid || '',
        clickid: cookieParsed.clickid || '',
        ttclid: cookieParsed.ttclid || '',
        tt_test_id: cookieParsed.tt_test_id || '',
      };
    }

    if (!this.cookieService.check('lead_referrer_string') && !this.cookieService.check('fruRemoveCookies')) {
      this.leadReferrerString = DefaultLeadReferrerString;
      let d = new Date();
      d.setDate(d.getDate() + 1);
      this.cookieService.set('lead_referrer_string', JSON.stringify(this.leadReferrerString), d, '/', this.cookieDomain);
    } else {
      let cookie = this.cookieService.get('lead_referrer_string');
      let cookieParsed;

      try {
        cookieParsed = JSON.parse(cookie);
      } catch (e) {
        cookieParsed = {};
      }

      this.leadReferrerString = {
        http_referer: cookieParsed.http_referer || '',
        request_uri: cookieParsed.request_uri || '',
      };
    }
  }

  setClickId() {
    let d = new Date();
    d.setHours(24, 0, 0, 0);

    if (this.route.snapshot.queryParams['click_id']) {
      this.cookieService.set('click_id', this.route.snapshot.queryParams['click_id'], d, '/', this.cookieDomain);
    }

    if (this.route.snapshot.queryParams['utm_term']) {
      this.cookieService.set('utm_term', this.route.snapshot.queryParams['utm_term'], d, '/', this.cookieDomain);
    }
  }

  getAdnetwork(): string {
    let adnetwork = '';

    // Get things from the query string
    this.route.queryParams.subscribe(params => {
      // Check for adnetwork in query string
      if (params.adnetwork) {
        adnetwork = params.adnetwork;
      } else {
        // Check for adnetwork in cookie
        let a: string = this.cookieService.get('lead_referrer');

        if (a) {
          // See if the cookie is new style
          try {
            let ad: LeadReferrer = JSON.parse(a);
            if (ad.source) {
              adnetwork = ad.source;
            }
          } catch (e) {
            // Old style cookie?
            try {
              adnetwork = atob(a);
              Sentry.captureMessage('Old style adnetwork cookie');
            } catch (err) {
              // Just don't set adnetwork
              Sentry.captureMessage('Unparseable adnetwork cookie');
            }
          }
        }
      }

      if (isDevMode()) {
        console.log('Using adnetwork', adnetwork);
      }
    });

    return adnetwork;
  }
}
